module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"titles":{"available_games":"Available Games","yesterdays_games":"Yesterday\u0027s Games","tomorrows_games":"Tomorrow\u0027s Games","no_games":"No games available today!","wait":"Please, wait..."},"statuses":{"your_active_game":"Your active game"}}}')
  delete Component.options._Ctor
}
